<arpio-center-panel>
  <h3 class="panel-title">Access Denied</h3>
  <div class="margin-top">
    You don't have permission to access this resource. This may be because your account doesn't have the required
    permissions, or your authentication has expired.
  </div>
  <div class="margin-top actions">
    <button class="primary-button" (click)="logout()">
      Go to login page
      <i class="fa-utility fa-semibold fa-arrow-right-from-bracket"></i>
    </button>
  </div>
  <div class="margin-top help-text">
    If you believe this is an error, please contact your system administrator or support team.
  </div>
</arpio-center-panel>
